<div class="flex justify-center pt-16">
    <div class="flex flex-col sm:flex-row gap-4 min-w-[384px] sm:min-w-[620px] md:min-w-[748px] items-center">
        <div class="flex flex-col gap-4 items-center text-center text-slate-700 p-8">
            <div class="text-xl sm:text-3xl font-bold font-title text-slate-900">
                <span class="">404 Not Found</span>
            </div> 
            <div>
                If you believe that this page is broken or missing then <a href="/about#contact" class="text-ponder-link hover:text-ponder-linkhover">please let us know</a>!
            </div>
        </div>
        <a href="/item/{{lostImageId}}" class="w-[284px] h-[398px] flex justify-center">
            <img class="mtg-card-rounded-sm sm:mtg-card-rounded card-shadow w-[277px] h-[388px] preview-hover" src="{{ lostImageUrl }}">
        </a>
    </div>
</div>